module["exports"] = [
  "вспомогательный",
  "основной",
  "внутренний",
  "цифровой",
  "свободно-распростроняемый",
  "виртуальный",
  "кросс-платформенный",
  "излишний",
  "онлайн",
  "сенсорный",
  "многобайтный",
  "беспроводной",
  "1080-пиксельный",
  "нейронный",
  "оптический",
  "твердотельный",
  "мобильный"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/hacker/adjective.js
// module id = 3527
// module chunks = 1610